function shouldUseSection(exchangeName, section) {
  if (!section || section === '????' || section.trim().length === 0) {
    return false;
  }

  if (exchangeName === 'TSE') {
    return true;
  }

  if (exchangeName === 'FSE' && (section === '0122' || section === '0123')) {
    return true;
  }

  if (exchangeName === 'SSE' && section === '0122') {
    return true;
  }

  return false;
}

/** Gets the Exchange resource ID and appends the exchange section if supported */
export function getExchangeResource(exchangeName, section, useLongJpName) {
  const exchangePrefix = 'exchange.' + exchangeName;
  if (shouldUseSection(exchangeName, section)) {
    return useLongJpName === true
      ? `${exchangePrefix}.${section}.long`
      : `${exchangePrefix}.${section}`;
  }

  return exchangePrefix;
}
